import { render, staticRenderFns } from "./desktopDeclination1.vue?vue&type=template&id=9804b836&scoped=true&"
import script from "./desktopDeclination1.vue?vue&type=script&lang=ts&"
export * from "./desktopDeclination1.vue?vue&type=script&lang=ts&"
import style0 from "./desktopDeclination1.vue?vue&type=style&index=0&id=9804b836&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9804b836",
  null
  
)

export default component.exports